import { render, staticRenderFns } from "./CSVOptions.vue?vue&type=template&id=0a4479b8&scoped=true&"
import script from "./CSVOptions.vue?vue&type=script&lang=js&"
export * from "./CSVOptions.vue?vue&type=script&lang=js&"
import style0 from "./CSVOptions.vue?vue&type=style&index=0&id=0a4479b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4479b8",
  null
  
)

export default component.exports